export default __webpack_public_path__ + "static/media/hide-icon.38c2f66d.svg";